/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_Why_Goal_ShortInputs */

const en_us2_intake_why_goal_short = /** @type {(inputs: Intake_Why_Goal_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Picks the rep ranges`)
};

const pt_br2_intake_why_goal_short = /** @type {(inputs: Intake_Why_Goal_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Define as faixas de repetições`)
};

const es_419_intake_why_goal_short = /** @type {(inputs: Intake_Why_Goal_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige los rangos de repeticiones`)
};

const pt_pt2_intake_why_goal_short = /** @type {(inputs: Intake_Why_Goal_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Define as gamas de repetições`)
};

const fr_fr2_intake_why_goal_short = /** @type {(inputs: Intake_Why_Goal_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisit les plages de répétitions`)
};

const de_de2_intake_why_goal_short = /** @type {(inputs: Intake_Why_Goal_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählt die Wiederholungsbereiche`)
};

const it_it2_intake_why_goal_short = /** @type {(inputs: Intake_Why_Goal_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sceglie i range di ripetizioni`)
};

/**
* | output |
* | --- |
* | "Picks the rep ranges" |
*
* @param {Intake_Why_Goal_ShortInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_why_goal_short = /** @type {((inputs?: Intake_Why_Goal_ShortInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Why_Goal_ShortInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_why_goal_short(inputs)
	if (locale === "es-419") return es_419_intake_why_goal_short(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_why_goal_short(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_why_goal_short(inputs)
	if (locale === "de-DE") return de_de2_intake_why_goal_short(inputs)
	if (locale === "it-IT") return it_it2_intake_why_goal_short(inputs)
	return en_us2_intake_why_goal_short(inputs)
});
export { intake_why_goal_short as "intake.why.goal.short" }